import { EmojiPicker, getTranslatedText } from '@nile/components';
import { Card, TextField, ToggleButton } from '@superops/ui-design-system';
import { isEmpty, isEqual } from 'lodash';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';

const CardTag = styled.div``;
const CardWrapper = styled.div`
  margin-top: ${({ margintop }) => (margintop ? '0' : '20px')};

  .mw-450 {
    max-width: 450px;
  }
`;
class DetailCard extends Component {
  constructor(props) {
    super(props);
    const { data } = this.props;
    const key = this.props.keyValue || 'name';
    const descriptionKey = this.props.descValue || 'description';
    this.state = {
      checked: data ? data.active : true,
      name: data[key] || '',
      description: data[descriptionKey] || '',
      emojiData: data.emoji || '😄'
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(this.props.data, prevProps.data)) {
      const key = this.props.keyValue || 'name';
      const descriptionKey = this.props.descValue || 'description';
      this.setState({
        checked: this.props?.data ? this.props?.data?.active : true,
        name: this.props?.data?.[key] || '',
        description: this.props?.data?.[descriptionKey] || ''
      });
    }
  }

  onEmojiChange = (emoji) => {
    this.setState({ emojiData: emoji?.[0] });
    this.props.actions.updateEmoji(emoji?.[0]);
  };

  handleChange(state) {
    this.setState({ checked: state });
    this.props.actions.updateActiveState(state);
  }

  changeName = (value) => {
    this.setState({ name: value });
    this.props.actions.updateName(value);
  };

  handleDescriptionChange = (value) => {
    this.setState({ description: value });
    if (this.props.actions.updateDescription) {
      this.props.actions.updateDescription(value);
    }
  };

  render() {
    const {
      intl,
      actions,
      meta,
      disableActive,
      notSectioned,
      id,
      children,
      errors,
      editDescription,
      noDesciption,
      className,
      noCard,
      nameLength,
      descriptionLength,
      noHeader,
      isNewLayout,
      noInputBorder,
      useEmojiPicker
    } = this.props;
    const { name, checked, description, emojiData } = this.state;
    const Tag = noCard ? CardTag : Card;
    return (
      <CardWrapper margintop={noCard}>
        <Tag
          sectioned={!notSectioned}
          customClassName={className || ''}
          padding="sizeSmall"
        >
          <div>
            {actions.updateName && (
              <>
                <div className="fx2 fx fw full-width" id={id}>
                  <div className="fx2 mw-450" id="detailCard.name">
                    <div className="flex-row gap-10 actr">
                      {useEmojiPicker && (
                        <EmojiPicker
                          onChange={this.onEmojiChange}
                          emoji={!isEmpty(emojiData) ? [emojiData] : null}
                          size="lg"
                        />
                      )}
                      <TextField
                        fontSize="fontLarge"
                        value={name}
                        onChange={this.changeName.bind(this)}
                        error={errors?.[0]}
                        placeholder={getTranslatedText(intl, 'common.name')}
                        noborder
                        size="default"
                        maxLength={nameLength}
                        disabled={this.props.disableEdit}
                      />
                    </div>
                  </div>

                  {!disableActive && (
                    <div className="fx2 jend fx" id="detailCard.switch">
                      <ToggleButton
                        value={checked}
                        onChange={this.handleChange.bind(this)}
                        labels={{
                          on: getTranslatedText(
                            intl,
                            'admin.slaPolicy.toggle.on'
                          ),
                          off: getTranslatedText(
                            intl,
                            'admin.slaPolicy.toggle.off'
                          )
                        }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          {!noDesciption && !editDescription ? (
            <p className="desc wm-500 mt-10">
              {description ||
                getTranslatedText(intl, 'admin.slaPolicy.desc.requests')}
            </p>
          ) : (
            !noDesciption && (
              <div
                className="w100 detail-card-description "
                id="detailCard.description"
                data-qa="detailCardInput"
              >
                <TextField
                  value={description}
                  multiline
                  size="default"
                  onChange={this.handleDescriptionChange.bind(this)}
                  placeholder={getTranslatedText(
                    intl,
                    'admin.slaPolicy.pl.description'
                  )}
                  maxLength={descriptionLength}
                  noborder
                  disabled={this.props.disableEdit}
                />
              </div>
            )
          )}
          {children && children}
        </Tag>
      </CardWrapper>
    );
  }
}

export default injectIntl(DetailCard);
